export enum WeightedModelsEnum {
  AG2 = 'AG2',
  WSI = 'WSI',
  GFS_OP = 'GFS_OP',
  GFS_ENS = 'GFS_ENS',
  ECMWF_OP = 'ECMWF_OP',
  ECMWF_ENS = 'ECMWF_ENS',
  GEM_OP = 'GEM_OP',
  GEM_ENS = 'GEM_ENS',
  ECMWF_AIFS = 'ECMWF_AIFS',
  ECMWF_AIFS_ENS = 'ECMWF_AIFS_ENS',
  MF_GFS_OP = 'MF_GFS_OP',
  MF_ECMWF_OP = 'MF_ECMWF_OP',
  MF_ECMWF_ENS = 'MF_ECMWF_ENS',
  MF_GEM_OP = 'MF_GEM_OP',
}
